import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { FINANCIAL_REPORTING_PERMISSIONS } from "@/constants/permissions"
import { FinancialReportingLayout } from "@/screens/FinancialReporting/components/FinancialReportingLayout"

export const Route = createFileRoute("/app/financial-reporting/_layout")({
  component: () => (
    <PermissionContentWrapper permissions={FINANCIAL_REPORTING_PERMISSIONS}>
      <FinancialReportingLayout />
    </PermissionContentWrapper>
  ),
})
